import { __awaiter, __generator } from "tslib";
import { importPolyfill } from './importPolyfill';
var textEncoder;
export function getTextEncoder() {
    return __awaiter(this, void 0, void 0, function () {
        var polyfill;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (textEncoder) {
                        return [2 /*return*/, textEncoder];
                    }
                    if ('TextEncoder' in window) {
                        textEncoder = new TextEncoder();
                        return [2 /*return*/, textEncoder];
                    }
                    return [4 /*yield*/, importPolyfill()];
                case 1:
                    polyfill = _a.sent();
                    textEncoder = new polyfill.TextEncoderLite();
                    return [2 /*return*/, textEncoder];
            }
        });
    });
}
//# sourceMappingURL=getTextEncoder.js.map